export default "__VITE_ASSET__63f9574c__"